import React from 'react'
import Modal from '../../../Modal'
import UbliqueColumn from '../Column'
import UbliqueRow from '../Row'
import cn from 'classnames'

import './index.scss'

const StripeModal = ({ className, stripeModal = {} }) => {
  const {
    config = {},
    modalProps = {},
    children,
    showModal,
    closeModal
  } = stripeModal
  return (
    <UbliqueRow className={cn('stripe-modal-row', className)}>
      <UbliqueColumn
        sm={config?.sm || 4}
        md={config?.md || 8}
        lg={config?.lg || 12}
      >
        <Modal
          className='stripe-modal'
          hasScrollingContent={false}
          modalHeading={modalProps.title}
          open={showModal}
          onRequestClose={closeModal}
          passiveModal={modalProps.passiveModal}
          selectorPrimaryFocus='[data-modal-primary-focus]'
          size={modalProps.size || 'lg'}
        >
          {children}
        </Modal>
      </UbliqueColumn>
    </UbliqueRow>
  )
}

export default StripeModal
